import type { VariablesOf } from "@graphql-typed-document-node/core";
import { ClientError } from "graphql-request";
import { safe, ErrorADT } from "pb.safe";

import { $, mutation } from "../../../../schema.dev-sdk-api-appsync.generated";
import { logger } from "../../../shared/logger";
import type { ApiClient } from "../shared/shared/api-client";

/**
 * Returns `true` if the given `terminalId` was successfully unpaired,
 * otherwise `false` if the given references were invalid, or an Error.
 */
export async function unpairDevice({
	apiClient,
	deviceId,
	terminalId,
}: {
	apiClient: ApiClient;
} & VariablesOf<typeof unpairDevice.gql.unpairDevice>): Promise<
	boolean | ErrorADT<"NetworkError">
> {
	const response = await safe(() =>
		apiClient.request(unpairDevice.gql.unpairDevice, {
			deviceId,
			terminalId,
		}),
	);
	if (response instanceof Error) {
		if (response instanceof ClientError) {
			const error = response.response.errors?.[0] as
				| { errorType?: string }
				| undefined;
			// It's okay if the given ID is invalid.
			// "[400] No existing paired devices found for the pairingUuid: ..."
			if (error?.errorType === "INVALID_REQUEST") {
				return false;
			}
		}
		logger.error("setup: unpairing device error", {
			errorName: response.name,
			errorMessage: response.message,
			errorStack: response.stack,
		});
		return ErrorADT("NetworkError");
	}

	return true;
}

unpairDevice.gql = {
	unpairDevice: mutation("unpairDevice", (q) => [
		q.unpairDevices({
			deviceUuid: $("deviceId"),
			input: [{ deviceUuid: $("terminalId") }],
		}),
	]),
};
